module.exports = __webpack_public_path__ + "img/mentalvideo.11594dcc.png";